
const defaultOptions = {
  width: 700,
  height: 520,
  menubar: "no",
  resizable: "yes",
  location: "yes",
  scrollbars: "no",
  centered: "yes",
};

const stringifyOptions = (options: any) => Object.keys(options)
  .map((key) => `${key}=${options[key]}`)
  .join(",");

const resolveOptions = (options: any) => {
  const { centered, ...result } = options;

  const width = window.outerWidth - options.width;
  const height = window.outerHeight - options.height;

  if (centered === "yes") {
    result.left = Math.round(window.screenX + width / 2);
    result.top = Math.round(window.screenY + height / 2.5);
  }

  return result;
};

export const popupInit = (name: any = "", options: any = {}) => {
  const opts = resolveOptions({ ...defaultOptions, ...options });
  const win = window.open("", name || "", stringifyOptions(opts));
  return win;
};

export const popupExecute = (win: any, url: any, callback: any) => {
  let isMessageReceived = false;
  let interval: any;

  const popupCallback = (err: any, data?: any) => {
    if (!isMessageReceived) {
      isMessageReceived = true;
      callback(err, data);
    }
  };

  const onMessage = (message: any) => {
    const data = message ? message.data : undefined;

    if (data) {
      popupCallback(undefined, data);
      window.removeEventListener("message", onMessage);
    }
  };

  window.addEventListener("message", onMessage, false);

  if (win) {
    win.location.href = url;
    win.focus();

    interval = setInterval(() => {
      if (win === null || win.closed) {
        clearInterval(interval);
        popupCallback(new Error("Popup closed"));
      }
    }, 100);
  } else {
    popupCallback(new Error("Popup blocked"));
  }
}
